// SPDX-License-Identifier: LicenseRef-MMS-WIRE
// Copyright (c) 2016-2026 Metal Management Solutions (Pty) Ltd

import {ExtraOptions, Routes} from '@angular/router';

import {SubroutePageOutletComponent} from "./subroute-page-outlet/subroute-page-outlet.component";

import {checkLoginGuard} from "../services/route-guards/check-login-guard.guard";
import {userContextLoadedGuard} from "../services/route-guards/user-context-loaded.guard";
import {onboardingUserGuard} from "../services/route-guards/onboarding-user.guard";
import {urlGuard} from "../services/route-guards/url-guard.guard";

export const routes: Routes = [{
    path: 'onboarding',
    canActivate: [checkLoginGuard, onboardingUserGuard],
    component: SubroutePageOutletComponent,
    loadChildren: () => import('./onboarding/onboarding-routing/onboarding-routing.module').then(m => m.OnboardingRoutingModule)
}, {
    path: 'view',
    canActivate: [checkLoginGuard, userContextLoadedGuard],
    children: [
        {
            path: 'jobs',
            loadChildren: () => import('../jobs/jobs.routes').then(m => m.JOBS_ROUTES)
        },
        {
            path: 'flowchart',
            loadChildren: () => import('../routes/flowchart.routes').then(m => m.flowchartRoutes)
        },
        {
            path: 'page_view',
            loadChildren: () => import('../routes/page-view.routes').then(m => m.pageViewRoutes)
        },
        {
            path: '',
            loadChildren: () => import('../routes/view-children.routes').then(m => m.viewChildrenRoutes)
        },
    ],
}, {
    path: '**',
    canActivate: [checkLoginGuard, userContextLoadedGuard, urlGuard],
    loadComponent: () => import('../page-view/page-view/page-view.component').then(m => m.PageViewComponent)
}];

const routerOptions: ExtraOptions = {
    onSameUrlNavigation: "reload",
}
